import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=aac11cac&"
import script from "./Department.vue?vue&type=script&lang=js&"
export * from "./Department.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aac11cac')) {
      api.createRecord('aac11cac', component.options)
    } else {
      api.reload('aac11cac', component.options)
    }
    module.hot.accept("./Department.vue?vue&type=template&id=aac11cac&", function () {
      api.rerender('aac11cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Department.vue"
export default component.exports